const loginForm = {
	items: [
		{ key: "email", type: "email", label: "Email", translate: "EMAIL", required: true, maxCharacter: 60 },
		{ key: "password", type: "password", label: "Password", translate: "PASSWORD", required: true, maxCharacter: 60 },
		{ type: "action", label: "Login", action: "SUBMIT" },
	],
};

export default loginForm;
